"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  inlineMenu: {
    display: 'flex'
  },
  inlineMenuWrapper: {
    [_theme.default.breakpoints.up('xs')]: {
      paddingBottom: '10px !important'
    },
    [_theme.default.breakpoints.up('sm')]: {
      paddingBottom: '3px !important'
    },
    [_theme.default.breakpoints.up('md')]: {
      paddingBottom: '3px !important'
    },
    [_theme.default.breakpoints.up('lg')]: {
      paddingBottom: '3px !important',
      paddingLeft: '15px !important'
    }
  }
});
var _default = exports.default = useStyles;